const environment = {
  host: '/accountmanagement/',
  isdev: false,
  url: '/accountmanagement/public',
  private_url: '/accountmanagement/private',
  google_site_key:'6LfflZ0aAAAAAE06qTkj4aXeLcvz6g9gvSviiONV'

}

export default environment;